import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
});

// Intercepteur request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('jeta_token');
  if (token) config.headers.Authorization = 'Bearer ' + token;
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
});

// Intercepteur response
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('jeta_token');
      window.location.href = '/login';
    }
    return Promise.reject(error.response?.data || error);
  }
);
// ====== AUTH ======
export const authService = {
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout')
};

// ====== DEMANDES ======
export const demandeService = {
  getAll: (params) => api.get('/demandes', { params }),
  getById: (id) => api.get(`/demandes/${id}`),
  create: (data) => api.post('/demandes', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  approuver: (id, data) => api.patch(`/demandes/${id}/approuver`, data),
  rejeter: (id, data) => api.patch(`/demandes/${id}/rejeter`, data),
  correction: (id, data) => api.patch(`/demandes/${id}/correction`, data),
  signer: (id, data) => api.post(`/demandes/${id}/signer`, data),
  updateStatut: (id, data) => api.patch(`/demandes/${id}/statut`, data),
  rechercher: (params) => api.get('/demandes/recherche', { params }),
  getStats: (filialeId) => api.get(`/demandes/stats/filiale/${filialeId}`)
};

// ====== FILIALES ======
export const filialeService = {
  // Le seuil PDG a sa propre route, reservee a l'administration.
  definirSeuil: (id, seuil) => api.patch(`/filiales/${id}/seuil-pdg`, { seuil_pdg: seuil }),
  getAll: () => api.get('/filiales'),
  create: (data) => api.post('/filiales', data),
  update: (id, data) => api.put(`/filiales/${id}`, data),
    getValidateurs: (id) => api.get('/filiales/' + id + '/validateurs'),  // ← AJOUTER
  uploadLogo: (id, formData) => api.post(`/filiales/${id}/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

};

// ====== USERS ======
export const userService = {
  getAll: () => api.get('/users'),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete('/users/' + id),
  toggleActif: (id, actif) => api.patch(`/users/${id}/actif`, { actif })
};

export const parametresService = {
  get: () => api.get('/parametres'),
  update: (data) => api.put('/parametres', data),
};


export default api;
